import * as React from 'react';
import { CaptionTypography, LoadingSpinner, LoadingSpinnerColor, LoadingSpinnerSize } from '@components/atoms';
import { cn } from '@utils';

/**
 * Interface for the props of the select loading state component.
 * @returns {ISelectLoadingStateProps} - The props object.
 */
export interface ISelectLoadingStateProps extends React.HTMLAttributes<HTMLDivElement> {
	label: string;
}

/**
 * Component for the loading state of the select component.
 * @param {ISelectLoadingStateProps} props - The props of the component.
 * @returns {React.ReactNode} - The loading state component.
 */
export const SelectLoadingState = ({
	className,
	label,
	...props
}: ISelectLoadingStateProps): React.ReactElement => {
	return (
		<div
			{...props}
			aria-live="polite"
			aria-busy="true"
			className={cn('flex min-h-12 items-center justify-center gap-2 px-4 py-3 text-center', className)}
			data-testid="select-loading-state"
			role="status"
		>
			<LoadingSpinner color={LoadingSpinnerColor.PRIMARY} size={LoadingSpinnerSize.SM} />
			<CaptionTypography className="text-secondary">{label}</CaptionTypography>
		</div>
	);
};
